import { companyAdvisorConnection as schema } from 'store/common/schemas';
import { createEntitiesReducer, createEntitiesSelector } from './helpers';

import * as userAdvisoryActionTypes from 'store/features/users/advisories/action-types';

export const reducer = createEntitiesReducer(schema, (state, action) => {
  switch (action.type) {
    case userAdvisoryActionTypes.REJECT_ADVISORY.SUCCESS:
      const { advisoryId: rejectedAdvisoryId } = action.payload;
      return rejectedAdvisoryId
        ? state.merge(
            {
              [rejectedAdvisoryId]: { rejectedTimestamp: new Date().toISOString() },
            },
            { deep: true }
          )
        : state;
    case userAdvisoryActionTypes.POLL_ADVISORY.START:
      const { advisoryId: pollingAdvisoryId } = action.payload;
      return pollingAdvisoryId
        ? state.merge(
            {
              [pollingAdvisoryId]: { polling: true },
            },
            { deep: true }
          )
        : state;
    case userAdvisoryActionTypes.POLL_ADVISORY.STOP:
      const { advisoryId: polledAdvisoryId } = action.payload;
      return polledAdvisoryId
        ? state.merge(
            {
              [polledAdvisoryId]: { polling: false },
            },
            { deep: true }
          )
        : state;
    case userAdvisoryActionTypes.MODIFY_SOFT_ADVISORY_STATUS: {
      const { advisoryId } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  status: 'PENDING',
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    default:
      return state;
  }
});

export const selector = createEntitiesSelector(schema);



// WEBPACK FOOTER //
// ./src/store/entities/company-advisor-connections.js